import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { NudgeLoginModule } from '../nudge-login/nudge-login.module';
import { StickyHeaderModule } from '../sticky-header/sticky-header.module';
import { SacPurposeModule } from './../sac-purpose/sac-purpose.module';
import { CommonHeaderComponent } from './components/common-header/common-header.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';
import { SipHamburgerComponent } from 'src/app/core/sip-hamburger/sip-hamburger.component';
import { CloseBtnModule } from '../close-btn/close-btn.module';

@NgModule({
  imports: [
    CommonModule,
    StickyHeaderModule,
    RouterModule,
    SacPurposeModule,
    FormsModule,
    SharedModule,
    ModuleLoaderModule,
    NudgeLoginModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatSidenavModule,
    ComponentLoader,
    SipHamburgerComponent,
    CloseBtnModule
  ],
  declarations: [CommonHeaderComponent],
  exports: [CommonHeaderComponent],
  bootstrap: [CommonHeaderComponent]
})
export class CommonHeaderModule {
  getComponent() {
    return CommonHeaderComponent;
  }
}
